<template>
  <div class="btns">
    <div class="btns__btn">
      <pr-button @click="toSubscribePage"> 訂閱電子報 </pr-button>
    </div>
    <div class="btns__btn">
      <pr-button @click="toHelpPage"> 我要提問 </pr-button>
    </div>
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import { useRouter } from 'vue-router';
import PrButton from '@/components/Global/PrButton.vue';

export default defineComponent({
  name: 'Buttons',
  components: {
    PrButton,
  },
  setup() {
    const router = useRouter();
    const toSubscribePage = () => {
      router.push({ name: 'subscribe' });
    };

    const toHelpPage = () => {
      router.push({ name: 'help' });
    };

    return {
      toSubscribePage,
      toHelpPage,

    };
  },
});
</script>
<style lang="scss" scoped>
@import '~@/styles/utils/_rwd.scss';

.btns {
  margin-top: 0px;

  &__btn {
    & + & {
      margin-top: 20px;
    }
  }
}

@media screen and (min-width: $tablet) {
  .btns {
    @include flex(center);
    margin-top: 30px;

    &__btn {
      & + & {
        margin-top: 0px;
        margin-left: 30px;
      }
    }
  }
}

@media screen and (min-width: $pc) {
  .btns {
    @include flex(center, flex-start, column);
    margin-top: 0px;

    &__btn {
      & + & {
        margin-top: 30px;
        margin-left: 0px;
      }
    }
  }
}
</style>
